import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import FullInfoField from 'components/FullInfoField/FullInfoField';

const ContentVersionField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return <FullInfoField label="contentVersionLabel" value={restaurantForFullInfo?.restaurantContentVersion} />;
};

export default ContentVersionField;
